module.exports = __webpack_public_path__ + "img/18_1902_non.45b4a574.jpg";